import FunnelStepChain from './FunnelStepChain';

export default FunnelStepChain;

export type { FunnelStepTag, IFunnelStep, IFunnelStepChainProps } from './FunnelStepChain';
